const IS_PRODUCTION = true;
const OPTION_IDS = {
    yesterday: 'yesterday',
    thisweek: 'lastWeek',
    last30days: 'last30days',
    quarter: 'quarter',
    sameDayLastMonth: 'sameDayLastMonth',
    last6months: 'last6months',
    last12months: 'last12months',
    yeartodate: 'yeartodate',
    lifetime: 'lifetime',
    custom: 'custom',
    thedaybefore: 'thedaybefore',
    samedaylastweek: 'samedaylastweek',
    questertodate: 'questertodate',
    samedaylastmonth: 'samedaylastmonth',
    samedaylastyear: 'samedaylastyear',
    comparedcustom: 'compared_custom',
};
const UPLOAD_URL = IS_PRODUCTION?'https://kims-fc-application.s3.ap-south-2.amazonaws.com/fc/uploads/':'https://kims-fc-application.s3.ap-south-2.amazonaws.com/testfc/uploads/';
const validRoomTypes = ["DELUXE", "DELUXE -C-19", "SUITE", "PREMIUM SUITE", "PRESIDENTIAL SUITE ROOM", "PSR" ];
const insuranceCompanyCodes = ['ORG61','ORG120','ORG126'];
const units = ['UN0','UN1','UN2','UN10','UN11'];
const serviceTypes = {
    I: "Investigations",
    PF: "Professional Fees",
    M: "Miscellaneous",
    P: "Pharmacy",
    C: "Consultations",
    S: "Services",
  };

const EMAIL = (IS_PRODUCTION) ? {
    'UN1':'insurance@kimshospitals.com',
    'UN2':'kon.insurance@kimshospitals.com',
    'UN3':'tpa@kimssaveera.com',
    'UN4':'insurance@kimskurnool.com',
    'UN5':'nlr.insurance@kimshospitals.com',
    'UN6':'ong.insurance@kimshospitals.com',
    'UN7':'rjy.insurance@kimshospitals.com',
    'UN8':'kimsssh.tpa2011@gmail.com',
    'UN9':'billing@kimsiconhospitals.com',
    'UN10':'insurance@kimssunshine.co.in',
    'UN11':'insurance.gbl@kimshospitals.com',
    'UN14':'tpa@kimskingsway.com',
    'UN15':'billingservices@kimsmanavata.net',
    'UN16':'insurance.kannur@kimshospitals.com',
    'UN17':'admissions.gnt@kimssikhara.com',
    'UN18':'fc.sdr@kimsvizag.com'
} : {
    'UN001':'insurance@kimshospitals.com',
    'UN002':'kon.insurance@kimshospitals.com',
    'UN003':'tpa@kimssaveera.com',
    'UN004':'insurance@kimskurnool.com',
    'UN005':'nlr.insurance@kimshospitals.com',
    'UN006':'ong.insurance@kimshospitals.com',
    'UN007':'rjy.insurance@kimshospitals.com',
    'UN008':'kimsssh.tpa2011@gmail.com',
    'UN009':'billing@kimsiconhospitals.com',
    'UN010':'insurance@kimssunshine.co.in',
    'UN011':'insurance.gbl@kimshospitals.com',
    'UN014':'tpa@kimskingsway.com',
    'UN015':'billingservices@kimsmanavata.net',
    'UN016':'insurance.kannur@kimshospitals.com',
    'UN017':'admissions.gnt@kimssikhara.com',
    'UN018':'fc.sdr@kimsvizag.com'

}
 
 export {OPTION_IDS,UPLOAD_URL,validRoomTypes,insuranceCompanyCodes,units,serviceTypes,EMAIL};